/**
 * Utility functions for extracting images and processing news items.
 */

export function getNewsImageUrl(item: any, size: 'small' | 'large' = 'small'): string | null {
  if (!item) return null;

  // Direct image property (e.g., FMP news or raw image field)
  if (typeof item.image === 'string' && item.image.trim() !== '') {
    return item.image.trim();
  }
  if (typeof item.thumbnailUrl === 'string' && item.thumbnailUrl.trim() !== '') {
    return item.thumbnailUrl.trim();
  }

  // Yahoo Finance thumbnail resolutions structure
  const resolutions = item.thumbnail?.resolutions;
  if (Array.isArray(resolutions) && resolutions.length > 0) {
    if (size === 'small') {
      // Find 140x140 or first resolution
      const smallRes = resolutions.find((r: any) => r.tag === '140x140' || (r.width && r.width <= 200));
      return smallRes?.url || resolutions[0]?.url || null;
    } else {
      // Find original or largest resolution
      const origRes = resolutions.find((r: any) => r.tag === 'original' || (r.width && r.width >= 400));
      return origRes?.url || resolutions[resolutions.length - 1]?.url || resolutions[0]?.url || null;
    }
  }

  if (typeof item.thumbnail?.originalUrl === 'string' && item.thumbnail.originalUrl.trim() !== '') {
    return item.thumbnail.originalUrl.trim();
  }

  return null;
}
